// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3wRJk","head":"ProcedureTableInfo_head__3V_Uq"};